export default "__VITE_ASSET__CrIWeM0d__"